import React from 'react';
import PropTypes from 'prop-types';
import { registerField } from 'core/forms';

import { Checkbox, TextInput } from 'uikit/inputs';

import styles from '../styles/formFieldBooleanInput.module.scss';

const FormFieldBooleanInput = ({
  fieldId,
  fieldKey,
  model,
  schema = { inputText: null, inputValueType: null, isDisabled: false, labelText: null },
  updateFields,
  value = false,
}) => {
  const onCheckboxChange = (updateValue) => {
    const updateObject = {};
    updateObject[fieldKey] = updateValue;

    if (updateValue === false && model[schema.inputValueKey]) {
      updateObject[schema.inputValueKey] = undefined;
    }

    updateFields(updateObject);
  };

  const onInputChange = (inputValue) => {
    const updateObject = {};
    let updatedValue = inputValue;

    if (schema.inputValueType === 'number') {
      updatedValue = parseInt(updatedValue, 10) || undefined;
    }

    updateObject[schema.inputValueKey] = updatedValue;

    updateFields(updateObject);
  };

  let inputFieldId = fieldId;

  if (schema.labelText) {
    inputFieldId = `${fieldId}-input`;
  }

  const inputValue = model[schema.inputValueKey];

  return (
    <div className={styles.element}>
      <Checkbox
        className={styles.checkbox}
        id={inputFieldId}
        name="checkbox"
        value={value}
        label={schema.labelText}
        isDisabled={schema.isDisabled}
        onChange={onCheckboxChange}
      />
      <div className={styles.inputWrap}>
        <TextInput
          id={fieldId}
          value={inputValue}
          onChange={onInputChange}
          disabled={schema.isDisabled}
          className={styles.input}
        />
        <label htmlFor={fieldId} className={styles.label}>{schema.inputText}</label>
      </div>
    </div>
  );
};

FormFieldBooleanInput.propTypes = {
  model: PropTypes.shape({}).isRequired,
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.bool,
  schema: PropTypes.shape({
    labelText: PropTypes.string,
    inputText: PropTypes.string,
    inputValueKey: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    inputValueType: PropTypes.string,
    isDisabled: PropTypes.bool,
  }),
  updateFields: PropTypes.func.isRequired,
};

registerField('BooleanInput', React.memo(FormFieldBooleanInput));

export default FormFieldBooleanInput;
